module.exports = __webpack_public_path__ + "media/audio2.f82bd257.mp3";